/** MaxAutoParts (maxautoparts.online) — single source for contact on all pages */
export const PHONE = '1-833-597-6924';
export const PHONE_RAW = '+18335976924';

export const COMPANY_NAME = 'Nodex Global';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS_FULL = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;

export const CONTACT = {
  phone: PHONE,
  phoneTel: PHONE_RAW,
  email: 'support@maxautoparts.online',
  website: 'maxautoparts.online',
  websiteUrl: 'https://www.maxautoparts.online',
  company: COMPANY_NAME,
  addressLine1: ADDRESS_LINE1,
  addressLine2: ADDRESS_LINE2,
  address: ADDRESS_FULL,
  hoursWeekdays: 'Mon–Fri: 8AM–8PM EST',
  hoursSaturday: 'Sat: 9AM–5PM EST',
};

export const phoneHref = `tel:${CONTACT.phoneTel}`;
